interface Params {
  offerId: string;
}

export const getUnclaimOfferUrl = ({ offerId }: Params): string =>
  `/offers/${offerId}/unclaim_offer`;
